export default __webpack_public_path__ + "static/media/Gráfica-2-AppertFlow-Web-4.4ce836ad.webp";